const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  // 调用图片翻译接口。
  translateImagePro ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/image/translate-image-pro', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  // 调用图片高清放大接口。
  imageEnlargement ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/image/image-enlargement', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  // 调用图片主体抠图接口。
  imageObjectExtraction ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/image/image-bbject-extraction', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  // 调用 AI 新品报告接口。
  selectionNewProductReport ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/selection/new-product-report', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      timeout: 180000,
      timeRetry: false
    })
  },
  // 调用 AI 关键词联想接口。
  selectionKeywordSearch ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/selection/keyword-search', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      timeout: 10000,
      timeRetry: false
    })
  },
  // 调用供应商信息搜索接口。
  supplierQuery ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/supplier/query', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      timeout: 10000,
      timeRetry: false,
      noShowError: true
    })
  },
  // 调用图片询盘任务提交接口。
  submitImageInquiryTask ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/task/submit-image', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      timeout: 20000,
      timeRetry: false,
      noShowError: true
    })
  },
  // 调用商品链接询盘任务提交接口。
  submitItemLinkInquiryTask ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/task/submit-item-link', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      timeout: 20000,
      timeRetry: false,
      noShowError: true
    })
  },
  // 调用询盘任务详情查询接口。
  queryInquiryTaskInfo ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ai/task/query-info', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      timeout: 10000,
      timeRetry: false,
      noShowError: true
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
